import React from "react";
import PropTypes from "prop-types";
import { getDate } from "utils/formatDate";
import { formatNumber } from "utils/currencyFormat";
import ReactDropdown from "react-dropdown";
import "react-dropdown/style.css";
import { ChoVayCombo } from "constants/choVayConst";
import Pagination from "react-js-pagination";
import choVayConst from "constants/choVayConst";
import { LaiSuatText } from "constants/choVayConst";
import { catChuoi } from "utils/stringExtension";
import {
  startAndEndOfWeek,
  formatDayMonth,
  startAndEndOfMonth,
  startAndEndOfYear,
  GetDateHomQua,
} from "utils/formatDate";
import SearchChoVay from "components/CommonComponent/SearchChoVay";
import GiaHanKy from "components/CommonComponent/GiaHanKy";
import { Dropdown } from "react-bootstrap";
import TraBotGoc from "components/CommonComponent/TraBotGoc";
import VayThem from "components/CommonComponent/VayThem";
import { API_AUTH } from "service/common";
import configs from "constants/configs";
import InChoVay from "containers/Common/QuanLyChoVay/inChoVay";
import { pushNotification } from "utils/notifications";
import DongLaiContainer from "containers/Common/QuanLyChoVay/dongLai";
import ButtonChuyenForm from "components/CommonComponent/ButtonChuyenForm";
import CustomerDetail from "containers/Common/Customer/customerDetail";
import InThuChiContainer from "containers/Common/ThuChi/InThuChiContainer";
import ChiTietHopDongContainer from "containers/Common/QuanLyChoVay/ChiTietHopDongContainer";
import DoiTinhTrangNoContainer from "containers/Common/QuanLyChoVay/DoiTinhTrangNoContainer";
import XoaHopDongContainer from "containers/Common/QuanLyChoVay/XoaHopDongContainer";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import GuiEmailContainer from "containers/Common/QuanLyChoVay/GuiEmailContainer";
import TinNhanContainer from "containers/Common/QuanLyChoVay/TinNhanContainer";
import { convertDate } from "utils/formatDate";
import { getTotalDays } from "utils/choVayUtils";
import { getLaiSuat } from "constants/choVayConst";
import ThemMoiTinChapContainer from "containers/TinChap/SubComponent/ThemMoiTinChapContainer";
import ThemMoiLoaiTaiSanContainer from "containers/Common/TaiSan/ThemMoiLoaiTaiSanContainer";
import TatToanContainer from "containers/Common/QuanLyChoVay/TatToanContainer";
import { Cookies } from "react-cookie";
import { XuatExcelTinChap } from "../CommonComponent/XuatExcel/TinChap";
import ChiTietSoTienDaTraContainer from "containers/Common/QuanLyChoVay/ChiTietSoTienDaTraContainer";
import ChiTietTongSoTienDaTraContainer from "containers/Common/QuanLyChoVay/ChiTietTongSoTienDaTraContainer";
import DoiTinhTrangNoApi from "service/doiTinhTrangNoApi";
import cauHinh from "utils/cauHinh";
import CauHinhApi from "../../service/cauHinhApi";
import { ModelQRThanhToanHD } from "components/TichHopBank/ModelQRThanhToanHD";
import userApi from "service/userApi";
import ThayDoiLaiSuat from "components/CommonComponent/ThayDoiLaiSuat";
import ThayDoiKyLai from "components/CommonComponent/ThayDoiKyLai";
import LayoutV2 from "containers/LayoutV2";
import { ModelThietLapHienThi } from "./ModelThietLapHienThi";
import ThietLapHienThiApi from "../../service/QuanTriHeThong/ThietLapHienThiApi";
import { formatCurrency2 } from "utils/currencyFormat";

class TinChap extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text1: "",
      showThemMoi: false,
      showDongLai: false,
      showTKNangCao: false,
      showGiaHanKy: false,
      showTraBotGoc: false,
      showVayThem: false,
      showThayDoiLaiSuat: false,
      showThayDoiKyThanhToan: false,
      showTatToan: false,
      showChiTietKhachHang: false,
      showInThuChi: false,
      showSaoChep: false,
      choVay: {},
      dataSearch: {
        dateFrom: "01/01/2001",
        dateTo: "01/01/4000",
        code: "",
        customerName: "",
        address: "",
        noteTaiSan: "",
        status: "5",
        debt: "-1",
        userName: "",
        pageIndex: 1,
        pageSize: 20,
        ThoiGian: "",
        taiSan: 0,
        manhanvien: "",
      },
      showInChoVay: false,
      thuChiId: 0,
      showChiTietHopDong: false,
      showDoiTinhTrangNo: false,
      choVayEdit: {},
      showXuatExcel3: false,
      showChiTietSoTienDaTra: false,
      showChiTietTongSoTienDaTra: false,
      isQRThanhToan: false,
      isShowModalQRThanhToanHD: false,
      itemDataQR: {},
      isCauHinhKhachHangBinhAn: false,
      isCauHinhKhachHangVSNY: false,
      showThayDoiKyLai: false,
      isShowModalThietLapHienThi: false,
      objThietLapHienThiDanhSach: {},
      listTinhTrangNo: [
        {
          value: "-1",
          label: "Tất cả",
        },
      ],
      listNhanVien: [
        {
          value: "-1",
          label: "Tất cả",
        },
      ],
    };
  }

  getNhanVienLabel = (value) => {
    const { listNhanVien } = this.state;
    if (!Array.isArray(listNhanVien) || value === "") return value;
    const found = listNhanVien.find((nv) => nv.value === value);
    return found ? found.label : value;
  };

  componentDidMount() {
    document.title = "Tín chấp | Phần mềm quản lý cầm đồ Morman";
    let { getComboUser, getConfig, getPhanQuyenTinChap } = this.props;
    getPhanQuyenTinChap();
    getConfig();
    getComboUser();
    this.getThietLapHienThi();
    //Code lấy tình trạng nợ
    DoiTinhTrangNoApi.getListTinhTrangNo().then((response) => {
      if (response.status === 200) {
        const dataComboTinhTrang = response.data.map((item) => ({
          value: item.Code,
          label: item.Name,
        }));
        const dataComboTinhTrangNew = [
          { value: "-1", label: "Tất cả" },
          ...dataComboTinhTrang,
        ];
        this.setState(
          { listTinhTrangNo: dataComboTinhTrangNew },
          this.getConfigKey
        );
      }
    });

    userApi.combo().then((response) => {
      if (response.status === 200) {
        const users = response.data.map((item) => ({
          value: item.value == "0" ? "" : item.value,
          label: item.label,
        }));
        this.setState({ listNhanVien: users });
      }
    });

    CauHinhApi.getConfigSys1().then((response) => {
      if (response.status === 200) {
        if (response.data.length > 0) {
          const configIsQRThanhToan = response.data.find(
            (e) =>
              e.keyConfig.toUpperCase() ===
              cauHinh.sKey.IsQRThanhToan.toUpperCase()
          );
          if (configIsQRThanhToan != null) {
            if (configIsQRThanhToan.valueConfig === "1") {
              this.setState({ isQRThanhToan: true });
            }
          }
        }
      }
    });
  }

  componentDidUpdate() {
    let { phanquyen, inthuchi } = this.props;
    let { showTatToan, dataSearch } = this.state;
    let { PhanQuyenTinChap, getPhanQuyenSuccess } = phanquyen;
    let { inThuChiShow } = inthuchi;
    let { laingay_danhsachlaingay } = PhanQuyenTinChap;

    if (
      getPhanQuyenSuccess &&
      (typeof laingay_danhsachlaingay === "undefined" ||
        laingay_danhsachlaingay === false)
    ) {
      //alert(laingay_danhsachlaingay);
      window.location.href = configs.errorLink;
    }
    if (showTatToan && inThuChiShow) {
      dataSearch.status = "2";
      this.setState({ showTatToan: false });
      this.loadTinChap(dataSearch);
    }
  }
  getThietLapHienThi() {
    ThietLapHienThiApi.thietLapDanhSachTinChap().then((response) => {
      this.setState({ objThietLapHienThiDanhSach: response.data });
    });
  }
  getConfigKey() {
    CauHinhApi.getConfigSys1().then((response) => {
      if (response.status === 200) {
        if (response.data.length > 0) {
          const configIsQRThanhToan = response.data.find(
            (e) =>
              e.keyConfig.toUpperCase() ===
              cauHinh.sKey.IsQRThanhToan.toUpperCase()
          );
          if (configIsQRThanhToan != null) {
            if (configIsQRThanhToan.valueConfig === "1") {
              this.setState({ isQRThanhToan: true });
            }
          }

          let { dataSearch } = this.state;
          const configNangCapKhachHangBinhAn = response.data.find(
            (e) =>
              e.keyConfig.toUpperCase() ===
              cauHinh.sKey.IsNangCapKHBinhAn.toUpperCase()
          );
          if (configNangCapKhachHangBinhAn != null) {
            if (configNangCapKhachHangBinhAn.valueConfig === "1") {
              dataSearch.debt = "999";
              this.setState({ isCauHinhKhachHangBinhAn: true });
              this.setState({ dataSearch });
            }
          }
          const configNangCapKhachHangVSNY = response.data.find(
            (e) =>
              e.keyConfig.toUpperCase() ===
              cauHinh.sKey.IsNangCapKHVSNY.toUpperCase()
          );
          if (configNangCapKhachHangVSNY != null) {
            if (configNangCapKhachHangVSNY.valueConfig === "1") {
              this.setState({ isCauHinhKhachHangVSNY: true });
            }
          }
          this.loadTinChap(dataSearch);
        }
      }
    });
  }
  onSearch = () => {
    let { dataSearch } = this.state;
    dataSearch.pageIndex = 1;
    this.setState({ dataSearch });
    this.loadTinChap(dataSearch);
  };
  loadTinChap(dataSearch) {
    let { getListTinChap } = this.props;
    getListTinChap(dataSearch);
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }
  getListData = () => () => {
    let { dataSearch } = this.state;
    //dataSearch.pageIndex = 1;
    this.setState({ dataSearch });
    this.loadTinChap(dataSearch);
  };
  onChangeData = (field, event) => {
    let { dataSearch } = this.state;
    if (field == "customerName") {
      var arr = event.target.value.split("|");
      if (arr.length == 7) {
        dataSearch.pageIndex = 1;
        dataSearch.customerName = arr[0];
        this.loadTinChap(dataSearch);
      } else {
        dataSearch[field] = event.target.value;
      }
    } else {
      dataSearch[field] = event.target.value;
    }
    this.setState({ dataSearch });
  };
  handleKeyDown = (event) => {
    if (event.key === "Enter") {
      let { dataSearch } = this.state;
      dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadTinChap(dataSearch);
    }
  };
  setModalTinChapShow = (chovay) => () => {
    let choVayEdit = { ...chovay };
    if (chovay) {
      choVayEdit.NgayVay = convertDate(chovay.NgayVay);
      choVayEdit.NgayTra = convertDate(chovay.NgayTra);
      choVayEdit.LaiSuat = getLaiSuat(chovay, chovay.KieuLaiSuat);
      choVayEdit.TongNgayVay = getTotalDays(
        choVayEdit.NgayVay,
        choVayEdit.NgayTra
      );
      if (choVayEdit.kyLai && parseFloat(choVayEdit.kyLai) > 0)
        choVayEdit.CountTypePaid = choVayEdit.kyLai;
    }
    this.setState({
      choVayEdit,
    });
    let { showFormTinChap, themmoitinchap } = this.props;
    this.props.themmoitinchap.postTinChapReturn = false;
    this.props.themmoitinchap.TaiSanTinChap.AnhTaiSan = "";
    let { isShowFormTinChap } = themmoitinchap;
    if (isShowFormTinChap) {
      let { dataSearch } = this.state;
      dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadTinChap(dataSearch);
    }
    showFormTinChap(choVayEdit);
  };
  setIsTinChapReturn = () => {
    this.props.themmoitinchap.postTinChapReturn = false;
  };
  setModalGiaHanShow = (data) => () => {
    this.setState({
      choVay: {},
    });
    let { showGiaHanKy } = this.state;
    if (data)
      this.setState({
        showGiaHanKy: !showGiaHanKy,
        choVay: data,
        showDongLai: false,
        showTKNangCao: false,
        showTraBotGoc: false,
        showVayThem: false,
        showThayDoiLaiSuat: false,
        showThayDoiKyThanhToan: false,
        showTatToan: false,
        showThayDoiKyLai: false,
      });
    else this.setState({ showGiaHanKy: !showGiaHanKy });
    if (showGiaHanKy) {
      let { dataSearch } = this.state;
      // dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadTinChap(dataSearch);
    }
  };
  setModalTatToanShow = (data) => () => {
    this.setState({
      choVay: {},
    });
    let { showTatToan } = this.state;
    if (data)
      this.setState({
        showTatToan: !showTatToan,
        choVay: data,
        showDongLai: false,
        showTKNangCao: false,
        showGiaHanKy: false,
        showTraBotGoc: false,
        showVayThem: false,
        showThayDoiLaiSuat: false,
        showThayDoiKyThanhToan: false,
        showThayDoiKyLai: false,
      });
    else this.setState({ showTatToan: !showTatToan });
    if (showTatToan) {
      let { dataSearch } = this.state;
      dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadTinChap(dataSearch);
    }
  };
  setModalTraBotGocShow = (data) => () => {
    this.setState({
      choVay: {},
    });
    let { showTraBotGoc } = this.state;
    if (data)
      this.setState({
        showTraBotGoc: !showTraBotGoc,
        choVay: data,
        showDongLai: false,
        showTKNangCao: false,
        showGiaHanKy: false,
        showVayThem: false,
        showThayDoiLaiSuat: false,
        showThayDoiKyThanhToan: false,
        showTatToan: false,
        showThayDoiKyLai: false,
      });
    else this.setState({ showTraBotGoc: !showTraBotGoc });
    if (showTraBotGoc) {
      let { dataSearch } = this.state;
      // dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadTinChap(dataSearch);
    }
  };
  setModalThayDoiLaiSuatShow = (data) => () => {
    this.setState({
      choVay: {},
    });
    let { showThayDoiLaiSuat } = this.state;
    if (data)
      this.setState({
        showThayDoiLaiSuat: !showThayDoiLaiSuat,
        choVay: data,
        showDongLai: false,
        showTKNangCao: false,
        showGiaHanKy: false,
        showThayDoiKyThanhToan: false,
        showTraBotGoc: false,
        showTatToan: false,
        showVayThem: false,
        showThayDoiKyLai: false,
      });
    else this.setState({ showThayDoiLaiSuat: !showThayDoiLaiSuat });
    if (showThayDoiLaiSuat) {
      let { dataSearch } = this.state;
      //dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadTinChap(dataSearch);
    }
  };

  setModalThayDoiKyThanhToanShow = (data) => () => {
    this.setState({
      choVay: {},
    });
    let { showThayDoiKyThanhToan } = this.state;
    if (data)
      this.setState({
        showThayDoiKyThanhToan: !showThayDoiKyThanhToan,
        choVay: data,
        showDongLai: false,
        showTKNangCao: false,
        showGiaHanKy: false,
        showThayDoiLaiSuat: false,
        showTraBotGoc: false,
        showTatToan: false,
        showVayThem: false,
        showThayDoiKyLai: false,
      });
    else this.setState({ showThayDoiKyThanhToan: !showThayDoiKyThanhToan });
    if (showThayDoiKyThanhToan) {
      let { dataSearch } = this.state;
      //dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadTinChap(dataSearch);
    }
  };

  setModalVayThemShow = (data) => () => {
    this.setState({
      choVay: {},
    });
    let { showVayThem } = this.state;
    if (data)
      this.setState({
        showVayThem: !showVayThem,
        choVay: data,
        showDongLai: false,
        showTKNangCao: false,
        showGiaHanKy: false,
        showTraBotGoc: false,
        showThayDoiLaiSuat: false,
        showThayDoiKyThanhToan: false,
        showTatToan: false,
        showThayDoiKyLai: false,
      });
    else this.setState({ showVayThem: !showVayThem });
    if (showVayThem) {
      let { dataSearch } = this.state;
      //dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadTinChap(dataSearch);
    }
  };

  setDongLaiModalShow = (data) => () => {
    this.setState({
      choVay: {},
    });
    if (data)
      this.setState({
        showDongLai: !this.state.showDongLai,
        choVay: data,
        showTKNangCao: false,
        showGiaHanKy: false,
        showTraBotGoc: false,
        showVayThem: false,
        showThayDoiLaiSuat: false,
        showThayDoiKyThanhToan: false,
        showTatToan: false,
        showThayDoiKyLai: false,
      });
    else this.setState({ showDongLai: !this.state.showDongLai });
    if (this.state.showDongLai) {
      let { dataSearch } = this.state;
      //dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadTinChap(dataSearch);
    }
  };
  setModalThayDoiKyLaiShow = (data) => () => {
    this.setState({
      choVay: {},
    });
    let { showThayDoiKyLai } = this.state;
    if (data)
      this.setState({
        showThayDoiKyLai: !showThayDoiKyLai,
        choVay: data,
        showTKNangCao: false,
        showGiaHanKy: false,
        showTraBotGoc: false,
        showVayThem: false,
        showThayDoiLaiSuat: false,
        showThayDoiKyThanhToan: false,
        showTatToan: false,
      });
    else this.setState({ showThayDoiKyLai: !showThayDoiKyLai });
    if (showThayDoiKyLai) {
      let { dataSearch } = this.state;
      this.setState({ dataSearch });
      this.loadTinChap(dataSearch);
    }
  };
  setTKNangCaoModalShow = (dataSearch) => {
    this.setState({ showTKNangCao: !this.state.showTKNangCao });
    if (dataSearch && dataSearch && this.state.showTKNangCao) {
      this.setState({ dataSearch });
      this.loadTinChap(dataSearch);
    }
  };
  setInChoVayModalShow = () => () => {
    let { showInChoVay, choVay } = this.state;
    if (choVay && !choVay.ChoVayId) {
      pushNotification("Hãy chọn hợp đồng", "warning", "TOP_CENTER", 1000);
      return;
    }
    this.setState({ showInChoVay: !showInChoVay });
  };
  setInChoVayModalShowTM = (choVay) => () => {
    let { showInChoVay } = this.state;
    if (choVay && !choVay.ChoVayId) {
      pushNotification("Hãy chọn hợp đồng", "warning", "TOP_CENTER", 1000);
      return;
    }
    this.setState({ choVay });
    this.setState({ showInChoVay: !showInChoVay });
  };
  setInThuChiModalShow = (thuChiId) => () => {
    let { showInPhieuThuChi } = this.props;
    showInPhieuThuChi(thuChiId);
  };
  setModalChiTietKhachHangShow = (choVay) => () => {
    let { showChiTietKhachHang } = this.state;
    if (choVay)
      this.setState({ showChiTietKhachHang: !showChiTietKhachHang, choVay });
    else this.setState({ showChiTietKhachHang: !showChiTietKhachHang });
  };
  setModalChiTietHopDongShow = (choVay) => () => {
    let { showChiTietHopDong } = this.state;
    if (choVay)
      this.setState({ choVay, showChiTietHopDong: !showChiTietHopDong });
  };
  setModalDoiTinhTrangNoShow = (choVay) => () => {
    let { showDoiTinhTrangNo } = this.state;
    if (choVay)
      this.setState({ choVay, showDoiTinhTrangNo: !showDoiTinhTrangNo });
    if (this.state.showDoiTinhTrangNo) {
      let { dataSearch } = this.state;
      // dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadTinChap(dataSearch);
    }
  };
  selectRow = (item) => () => {
    this.setState({ choVay: item });
  };
  setModalSaoChepShow = (chovay) => () => {
    let choVayEdit = { ...chovay, IsCopy: true };
    if (chovay) {
      choVayEdit.NgayVay = new Date();
      choVayEdit.NgayTra = convertDate(chovay.NgayTra);
      choVayEdit.LaiSuat = getLaiSuat(chovay, chovay.KieuLaiSuat);
      choVayEdit.TongNgayVay = getTotalDays(
        choVayEdit.NgayVay,
        choVayEdit.NgayTra
      );
    }
    this.setState({
      choVayEdit,
    });
    let { showFormTinChap, themmoitinchap } = this.props;
    let { isShowFormTinChap } = themmoitinchap;
    if (isShowFormTinChap) {
      let { dataSearch } = this.state;
      dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadTinChap(dataSearch);
    }
    showFormTinChap(choVayEdit);
  };
  hideModalLoaiTaiSanTM = () => {
    let { showModalLoaiTaiSan } = this.props;
    showModalLoaiTaiSan(false);
  };

  setModalChiTietTienDaTraShow = (choVay) => () => {
    let { showChiTietSoTienDaTra } = this.state;
    if (choVay)
      this.setState({
        showChiTietSoTienDaTra: !showChiTietSoTienDaTra,
        choVay,
      });
    else this.setState({ showChiTietSoTienDaTra: !showChiTietSoTienDaTra });
  };

  setModalChiTietTongTienDaTraShow = () => () => {
    let { showChiTietTongSoTienDaTra, IsNangCapKHVSNY } = this.state;
    this.setState({ showChiTietTongSoTienDaTra: !showChiTietTongSoTienDaTra });
  };

  renderTableRows() {
    let {
      tinchap,
      showXoaHopDong,
      showInMaVachTaiSan,
      showModalGuiEmail,
      showModalGuiTinNhan,
      phanquyen,
    } = this.props;
    let {
      choVay,
      isQRThanhToan,
      isCauHinhKhachHangVSNY,
      objThietLapHienThiDanhSach,
    } = this.state;
    let isShow = false;
    if (matchMedia) {
      var mq = window.matchMedia("(max-width: 768px)");
      isShow = mq.matches;
    }
    let { PhanQuyenTinChap } = phanquyen;
    let {
      laingay_doitinhtranghopdong,
      laingay_donglailaingay,
      laingay_giahanlaingay,
      laingay_guiemail,
      laingay_nhantin,
      laingay_sualaingay,
      laingay_tattoanlaingay,
      laingay_thongtinchitiethopdong,
      laingay_thongtinchitietkhachhang,
      laingay_trabotgoc,
      laingay_vaythem,
      laingay_thaydoilaisuat,
      laingay_thaydoikylai,
      laingay_xoalaingay,
      SuDungCongTacVienNhanVien,
      SuDungSoTienVayConLai,
      SuDungMaNhanVien,
      SuDungTatToanSom,
    } = PhanQuyenTinChap;
    return tinchap.objList.List.map((item, index) => (
      <div
        className={
          "custom-table-row " + (item === choVay && !isShow ? "active" : "")
        }
        key={"item" + index}
        onClick={this.selectRow(item)}
      >
        {item.DebtLevel === 50 && (
          <span className="line-job-color job-color-picker-1"></span>
        )}
        {item.DebtLevel === 20 && (
          <span className="line-job-color job-color-picker-2"></span>
        )}
        {objThietLapHienThiDanhSach.IsAnSTT != true && (
          <div className="custom-table-cell username-cell flex-basis-4 flex-basis-6-sm disk-mobile">
            <span className="mobile-column-name color7-bold">STT</span>
            <div className="center-wrapper">
              <p className="center-flex color7">{item.IndexId}</p>
            </div>
          </div>
        )}
        {isCauHinhKhachHangVSNY == false && (
          <>
            {objThietLapHienThiDanhSach.IsAnMaHD != true && (
              <div className="custom-table-cell flex-basis-9 flex-basis-12-sm">
                <span className="mobile-column-name color7-bold">
                  Mã hợp đồng
                </span>
                <div className="center-wrapper">
                  <span className="profile_name word-break ">
                    {laingay_thongtinchitiethopdong ? (
                      <a
                        id=""
                        href={() => false}
                        className="blue btn-link"
                        onClick={this.setModalChiTietHopDongShow(item)}
                      >
                        {item.Code}
                      </a>
                    ) : (
                      item.Code
                    )}
                  </span>
                  <span className="font-lai">
                    <br />
                    {getDate(item.NgayVay)}
                    <br />
                    {getDate(item.NgayTra)}
                  </span>
                </div>
              </div>
            )}
            {objThietLapHienThiDanhSach.IsAnNhanVien != true &&
              (SuDungCongTacVienNhanVien || SuDungMaNhanVien) && (
                <div className="custom-table-cell flex-basis-6 flex-basis-6-sm">
                  <span className="mobile-column-name color7-bold">
                    {SuDungCongTacVienNhanVien ? "Mã nhân viên" : "Nhân viên"}
                  </span>
                  <div className="center-wrapper color7">
                    <p
                      className="text-left text-truncate"
                      style={{
                        maxWidth: "80px",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        margin: 0,
                      }}
                      title={this.getNhanVienLabel(item.MaNhanVien)}
                    >
                      {this.getNhanVienLabel(item.MaNhanVien)}
                    </p>
                  </div>
                </div>
              )}
            {objThietLapHienThiDanhSach.IsAnTenKH != true && (
              <div
                className={`custom-table-cell ${
                  SuDungCongTacVienNhanVien || SuDungMaNhanVien
                    ? "flex-basis-12 flex-basis-11-8-sm"
                    : "flex-basis-10 flex-basis-11-8-sm"
                }`}
              >
                {/* <div className="custom-table-cell flex-basis-12 flex-basis-11-8-sm"> */}
                <span className="mobile-column-name color7-bold">
                  Tên khách hàng
                </span>
                <div className="center-wrapper color7">
                  <p>
                    {laingay_thongtinchitietkhachhang ? (
                      <a
                        id=""
                        href={() => false}
                        className="blue btn-link"
                        onClick={this.setModalChiTietKhachHangShow(item)}
                      >
                        <span> {item.CustomerName}</span>
                      </a>
                    ) : (
                      <span>{item.CustomerName}</span>
                    )}

                    <br />
                    {item.phoneCus && (
                      <span title={item.phoneCus} className="font-lai color7">
                        {" "}
                        {catChuoi(item.phoneCus, 10)}
                      </span>
                    )}
                  </p>
                </div>
              </div>
            )}
          </>
        )}
        {isCauHinhKhachHangVSNY == true && (
          <>
            {objThietLapHienThiDanhSach.IsAnTenKH != true && (
              <div
                className={`custom-table-cell ${
                  SuDungCongTacVienNhanVien || SuDungMaNhanVien
                    ? "flex-basis-12 flex-basis-11-8-sm"
                    : "flex-basis-10 flex-basis-11-8-sm"
                }`}
              >
                {/* <div className="custom-table-cell flex-basis-12 flex-basis-11-8-sm"> */}
                <span className="mobile-column-name color7-bold">
                  Tên khách hàng
                </span>
                <div className="center-wrapper color7">
                  <p>
                    {laingay_thongtinchitietkhachhang ? (
                      <a
                        id=""
                        href={() => false}
                        className="blue btn-link"
                        onClick={this.setModalChiTietKhachHangShow(item)}
                      >
                        {item.CustomerName}
                      </a>
                    ) : (
                      <span>{item.CustomerName}</span>
                    )}

                    <br />
                    {item.phoneCus && (
                      <span title={item.phoneCus} className="font-lai color7">
                        {" "}
                        {catChuoi(item.phoneCus, 10)}
                      </span>
                    )}
                  </p>
                </div>
              </div>
            )}
            {objThietLapHienThiDanhSach.IsAnMaHD != true && (
              <div className="custom-table-cell flex-basis-9 flex-basis-12-sm">
                <span className="mobile-column-name color7-bold">
                  Mã hợp đồng
                </span>
                <div className="center-wrapper">
                  <span className="profile_name color7 font-lai">
                    {laingay_thongtinchitiethopdong ? (
                      <a
                        id=""
                        href={() => false}
                        className="blue btn-link"
                        onClick={this.setModalChiTietHopDongShow(item)}
                      >
                        {item.Code}
                      </a>
                    ) : (
                      item.Code
                    )}
                    <br />
                    {getDate(item.NgayVay)}
                    <br />
                    {getDate(item.NgayTra)}
                  </span>
                </div>
              </div>
            )}

            {objThietLapHienThiDanhSach.IsAnNhanVien != true &&
              (SuDungCongTacVienNhanVien || SuDungMaNhanVien) && (
                <div className="custom-table-cell flex-basis-6 flex-basis-6-sm">
                  <span className="mobile-column-name color7-bold">
                    {SuDungCongTacVienNhanVien ? "Mã nhân viên" : "Nhân viên"}
                  </span>
                  <div className="center-wrapper color7">
                    <p
                      className="text-left text-truncate"
                      style={{
                        maxWidth: "80px",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        margin: 0,
                      }}
                      title={this.getNhanVienLabel(item.MaNhanVien)}
                    >
                      {this.getNhanVienLabel(item.MaNhanVien)}
                    </p>
                  </div>
                </div>
              )}
          </>
        )}
        {objThietLapHienThiDanhSach.IsAnTinChap != true && (
          <div className="custom-table-cell flex-basis-8 flex-basis-6-sm">
            <span className="mobile-column-name color7-bold">Tín chấp</span>
            <div className="center-wrapper color7">
              <p className="text-center" title={item.TaiSan}>
                {catChuoi(item.TaiSan, 10)}
              </p>
            </div>
          </div>
        )}
        {objThietLapHienThiDanhSach.IsAnSoTienVay != true &&
          this.state.isCauHinhKhachHangBinhAn == false && (
            <div className="custom-table-cell flex-basis-9-5 flex-basis-13-sm">
              <span className="mobile-column-name color7-bold">
                Số tiền vay
              </span>
              <div className="center-wrapper">
                <p className="text-right color7">
                  <span className="fontnew-500  color-do-bold">
                    {formatNumber(item.SoTienVayConLai)}
                  </span>{" "}
                  <br />{" "}
                  <span className="font-lai color7">
                    (Lãi suất: {LaiSuatText(item, item.KieuLaiSuat)})
                  </span>
                </p>
              </div>
            </div>
          )}
        {this.state.isCauHinhKhachHangBinhAn == true && (
          <div className="custom-table-cell flex-basis-9-5 flex-basis-13-sm">
            <span className="mobile-column-name color7-bold">
              Tiền đưa khách{" "}
            </span>
            <div className="center-wrapper">
              <p className="text-right">
                <span className="fontnew-500">
                  {formatNumber(item.SoTienVayConLai)}
                </span>{" "}
                <br />{" "}
                <span className="font-lai">
                  (Lãi suất: {LaiSuatText(item, item.KieuLaiSuat)})
                </span>
              </p>
            </div>
          </div>
        )}
        {objThietLapHienThiDanhSach.IsAnSoTienDaTra != true && (
          <div className="custom-table-cell flex-basis-9-5 flex-basis-13-sm">
            <span className="mobile-column-name color7-bold">
              Số tiền đã trả
            </span>
            <div className="center-wrapper">
              <p className="text-right">
                <a
                  id=""
                  href={() => false}
                  className="blue btn-link"
                  onClick={this.setModalChiTietTienDaTraShow(item)}
                >
                  {formatNumber(
                    item.TC_ValueGoc +
                      item.TC_ValueLai +
                      item.TC_PhiKho +
                      item.TC_OtheFeeHangKy +
                      item.TC_Amercement +
                      item.TC_OtherFee +
                      item.TC_PhiPhatDongLai +
                      item.TC_PhiHoaHongTraGop +
                      item.TC_PhiPhatTatToan
                  )}
                  {/* {formatNumber(item.Paided)} */}
                </a>
              </p>
            </div>
          </div>
        )}
        {objThietLapHienThiDanhSach.IsAnTienVayConLai != true && (
          <div className="custom-table-cell flex-basis-9-5 flex-basis-13-sm">
            <span className="mobile-column-name color7-bold">
              Tiền vay còn lại
            </span>
            <div className="center-wrapper">
              <p className="text-right">
                <span className="fontnew-500 color7-bold">
                  {formatNumber(item.GocConLai)}
                </span>{" "}
              </p>
            </div>
          </div>
        )}
        {objThietLapHienThiDanhSach.IsAnChiPhiVayToiHomNay != true && (
          <div className="custom-table-cell flex-basis-9-5 flex-basis-13-sm">
            <span className="mobile-column-name color7-bold">
              Lãi đến hôm nay
            </span>
            <div className="center-wrapper">
              <p className="text-right  ">
                <span className="color7-bold">
                  {formatNumber(item.PaidToDateNow)}
                </span>
                <br />
                <span className="font-lai">
                  {/* Dư nợ giảm dần rải theo kỳ nên đơn vị là kỳ, giống màn cầm đồ */}
                  {item.IsDuNoGiamDan === true
                    ? "(" + item.SoNgayChuaDong + " kỳ)"
                    : (item.KieuLaiSuat === 4 ||
                        item.KieuLaiSuat === 5 ||
                        item.TypePaid === 3) &&
                      item.SoNgayChuaDong > 0
                    ? "(" + item.SoNgayChuaDong + " kỳ)"
                    : (item.KieuLaiSuat === 6 || item.KieuLaiSuat === 7) &&
                      item.SoNgayChuaDong > 0
                    ? "(" + item.SoNgayChuaDong + " tuần)"
                    : item.SoNgayChuaDong > 0
                    ? "(" + item.SoNgayChuaDong + " ngày)"
                    : ""}
                </span>
              </p>
            </div>
          </div>
        )}
        {objThietLapHienThiDanhSach.IsAnTrangThai != true && (
          <div className="custom-table-cell flex-basis-8 flex-basis-8-sm">
            <span className="mobile-column-name color7-bold">Trạng thái</span>
            <div className="center-wrapper">
              <p className="text-center">
                <span
                  className={
                    item.Status === 4
                      ? "canh-bao-red-v2"
                      : item.Status === 3
                      ? "canh-bao-no"
                      : item.Status === 2
                      ? "dong"
                      : "dang-vay"
                  }
                >
                  {choVayConst.StatusText[item.Status]}
                </span>
              </p>
            </div>
          </div>
        )}
        {objThietLapHienThiDanhSach.IsAnChucNang != true && (
          <div className="custom-table-cell flex-basis-16 flex-basis-15-6-sm  action-cell">
            <div className="center-wrapper">
              {item.Status !== 2 && (
                <div className="iconTableMorman">
                  {laingay_sualaingay && (
                    <a
                      href={() => false}
                      onClick={this.setModalTinChapShow(item)}
                    >
                      <PopoversBootrap
                        contentText="Sửa"
                        titleText=""
                        // trigger={['hover', 'focus']}
                        placement={"top"}
                      >
                        <img src="/app-assets/images/icon-edit-v2.png" />
                      </PopoversBootrap>
                    </a>
                  )}
                  {laingay_donglailaingay && (
                    <a
                      onClick={this.setDongLaiModalShow(item)}
                      href={() => false}
                    >
                      <PopoversBootrap
                        contentText="Đóng lãi"
                        titleText=""
                        trigger={["hover", "focus"]}
                        placement={"top"}
                      >
                        <span className="dong-lai-button"></span>
                      </PopoversBootrap>
                    </a>
                  )}

                  {laingay_tattoanlaingay && (
                    <a
                      href={() => false}
                      onClick={this.setModalTatToanShow(item)}
                    >
                      <PopoversBootrap
                        contentText="Tất toán"
                        titleText=""
                        trigger={["hover", "focus"]}
                        placement={"top"}
                      >
                        <span className="tat-toan-button"></span>
                      </PopoversBootrap>
                    </a>
                  )}

                  {laingay_trabotgoc &&
                    item.IsDuNoGiamDan !== true &&
                    item.IsKieuTraGocLai !== true && (
                      <a
                        href={() => false}
                        onClick={this.setModalTraBotGocShow(item)}
                      >
                        <PopoversBootrap
                          contentText="Trả bớt gốc"
                          titleText=""
                          trigger={["hover", "focus"]}
                          placement={"top"}
                        >
                          <img src="/app-assets/images/icon-tra-bot-goc-v2.png" />
                        </PopoversBootrap>
                      </a>
                    )}
                  {laingay_vaythem &&
                    item.IsDuNoGiamDan !== true &&
                    item.IsKieuTraGocLai !== true && (
                      <a
                        href={() => false}
                        onClick={this.setModalVayThemShow(item)}
                      >
                        <PopoversBootrap
                          contentText="Vay thêm"
                          titleText=""
                          trigger={["hover", "focus"]}
                          placement={"top"}
                        >
                          <img src="/app-assets/images/icon-vay-them-v2.png" />
                        </PopoversBootrap>
                      </a>
                    )}

                  {/* {isQRThanhToan && (
                  <a
                    className="dropdown-item"
                    onClick={this.setModalQRThanhToanShow(item)}
                    href={() => false}
                  >
                    <PopoversBootrap
                      contentText="QR thanh toán"
                      titleText=""
                      trigger={["hover", "focus"]}
                      placement={"top"}
                    >
                      <img src="/app-assets/images/icon-qrcode-v2.png" />
                    </PopoversBootrap>
                  </a>
                )} */}

                  <Dropdown className="DropNew trangthai-new dropdown-toggle">
                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                      <img
                        src="/app-assets/images/icon-more.png"
                        alt="Dropdown icon"
                        className="dropdown-icon"
                      />
                    </Dropdown.Toggle>

                    <Dropdown.Menu
                      className="dropdown-menu-v2 arrow"
                      style={{ borderRadius: "10px" }}
                    >
                      <div className="block-iconmm vertical-layout">
                        {laingay_giahanlaingay &&
                          item.IsDuNoGiamDan !== true &&
                          item.IsKieuTraGocLai !== true && (
                            <a
                              className="dropdown-item"
                              href={() => false}
                              onClick={this.setModalGiaHanShow(item)}
                            >
                              <PopoversBootrap
                                titleText=""
                                trigger={["hover", "focus"]}
                                placement={"top"}
                              >
                                <img src="/app-assets/images/icon-gia-han.png" />
                              </PopoversBootrap>
                              <span class="vertical-align-v2">Gia hạn</span>
                            </a>
                          )}
                        {laingay_thaydoilaisuat &&
                          item.IsDuNoGiamDan !== true && (
                            <a
                              href={() => false}
                              onClick={this.setModalThayDoiLaiSuatShow(item)}
                            >
                              <PopoversBootrap
                                contentText="Đổi lãi suất"
                                titleText=""
                                trigger={["hover", "focus"]}
                                placement={"top"}
                              >
                                <img
                                  src="/app-assets/images/icon-thay-doi-lai-suat-v3.png"
                                  style={{
                                    transform: "scale(1.3)",
                                    marginRight: "6px",
                                    marginLeft: "15px",
                                  }}
                                />
                              </PopoversBootrap>
                              <span class="vertical-align-v2">
                                Đổi lãi suất
                              </span>
                            </a>
                          )}
                        {laingay_thaydoikylai &&
                          item.IsDuNoGiamDan === false && (
                            <a
                              className="dropdown-item"
                              href={() => false}
                              onClick={this.setModalThayDoiKyLaiShow(item)}
                            >
                              <PopoversBootrap
                                contentText="Đổi kỳ lãi"
                                titleText=""
                                trigger={["hover", "focus"]}
                                placement={"top"}
                              >
                                <img
                                  src="/app-assets/images/icon-thay-doi-lai-suat-v3.png"
                                  style={{
                                    transform: "scale(1.3)",
                                    marginRight: "6px",
                                    marginLeft: "5px",
                                  }}
                                />
                              </PopoversBootrap>
                              <span class="vertical-align-v2">Đổi kỳ lãi</span>
                            </a>
                          )}
                        {laingay_nhantin && (
                          <a
                            className="dropdown-item"
                            href={() => false}
                            onClick={showModalGuiTinNhan}
                          >
                            <PopoversBootrap
                              contentText="Nhắn tin"
                              titleText=""
                              trigger={["hover", "focus"]}
                              placement={"top"}
                            >
                              <img src="/app-assets/images/icon-tin-nhan.png" />
                            </PopoversBootrap>
                            <span class="vertical-align-v2">Nhắn tin</span>
                          </a>
                        )}

                        {laingay_guiemail && (
                          <a
                            className="dropdown-item"
                            href={() => false}
                            onClick={showModalGuiEmail}
                          >
                            <PopoversBootrap
                              contentText="Gửi Email"
                              titleText=""
                              trigger={["hover", "focus"]}
                              placement={"top"}
                            >
                              <img src="/app-assets/images/icon-gui-mail.png" />
                            </PopoversBootrap>
                            <span class="vertical-align-v2">Gửi Email</span>
                          </a>
                        )}
                        {laingay_doitinhtranghopdong && (
                          <a
                            className="dropdown-item"
                            href={() => false}
                            onClick={this.setModalDoiTinhTrangNoShow(item)}
                          >
                            <PopoversBootrap
                              contentText="Đổi tình trạng nợ"
                              titleText=""
                              trigger={["hover", "focus"]}
                              placement={"top"}
                            >
                              <img src="/app-assets/images/icon-doi-tinh-trang-no.png" />
                            </PopoversBootrap>
                            <span class="vertical-align-v2">
                              Đổi tình trạng nợ
                            </span>
                          </a>
                        )}
                        {isQRThanhToan && (
                          <a
                            className="dropdown-item"
                            onClick={this.setModalQRThanhToanShow(item)}
                            href={() => false}
                          >
                            <PopoversBootrap
                              contentText="QR thanh toán"
                              titleText=""
                              trigger={["hover", "focus"]}
                              placement={"top"}
                            >
                              <img
                                src="/app-assets/images/icon-qrcode-v2.png"
                                hidden={!isQRThanhToan}
                              />
                            </PopoversBootrap>
                            <span class="vertical-align-v2">QR code</span>
                          </a>
                        )}
                        {laingay_xoalaingay && (
                          <a
                            className="dropdown-item"
                            href={() => false}
                            onClick={showXoaHopDong}
                          >
                            <PopoversBootrap
                              contentText="Xoá"
                              titleText=""
                              trigger={["hover", "focus"]}
                              placement={"top"}
                            >
                              <img
                                style={{ marginLeft: "5px" }}
                                src="/app-assets/images/icon-xoa-v2.png"
                              />
                            </PopoversBootrap>
                            <span
                              class="vertical-align-v2"
                              style={{ color: "#FF5170", marginLeft: "10px" }}
                            >
                              Xóa
                            </span>
                          </a>
                        )}
                      </div>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              )}

              {item.Status === 2 && (
                <div className="iconTableMorman">
                  <a
                    onClick={this.setModalSaoChepShow(item)}
                    href={() => false}
                  >
                    <PopoversBootrap
                      contentText="Sao chép"
                      titleText=""
                      trigger={["hover", "focus"]}
                      placement={"top"}
                    >
                      <i className="mdi mdi-content-copy"></i>
                    </PopoversBootrap>
                  </a>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    ));
  }

  handlePageChange = (pageNumber) => {
    let { dataSearch } = this.state;
    dataSearch.pageIndex = pageNumber;
    this.setState({ dataSearch });
    this.loadTinChap(dataSearch);
  };
  _onSelect = (field) => (value) => {
    let { dataSearch } = this.state;
    dataSearch[field] = value.value;
    this.setState({ dataSearch });
  };
  _onSelectDate = (field) => (value) => {
    let { dataSearch } = this.state;
    dataSearch[field] = value.value;
    dataSearch.dateFrom = "01/01/2001";
    dataSearch.dateTo = "01/01/4001";
    if (value.value === "1") {
      dataSearch.dateFrom = formatDayMonth(new Date());
      dataSearch.dateTo = formatDayMonth(new Date());
    }
    if (value.value === "2") {
      var date2s = startAndEndOfWeek(new Date());
      dataSearch.dateFrom = formatDayMonth(date2s[0]);
      dataSearch.dateTo = formatDayMonth(date2s[1]);
    }
    if (value.value === "3") {
      var date1s = startAndEndOfMonth(new Date());
      dataSearch.dateFrom = formatDayMonth(date1s[0]);
      dataSearch.dateTo = formatDayMonth(date1s[1]);
    }
    if (value.value === "4") {
      var date4s = startAndEndOfYear(new Date());
      dataSearch.dateFrom = formatDayMonth(date4s[0]);
      dataSearch.dateTo = formatDayMonth(date4s[1]);
    }
    // Hôm qua
    if (value.value === "5") {
      dataSearch.dateFrom = GetDateHomQua();
      dataSearch.dateTo = GetDateHomQua();
    }
    this.setState({ dataSearch });
  };
  onChangeText = (field) => (value) => {
    let { dataSearch } = this.state;
    dataSearch[field] = value.target.value;
    this.setState({ dataSearch });
  };
  xuatExcel = () => () => {
    let { dataSearch } = this.state;
    let {
      dateFrom,
      dateTo,
      code,
      customerName,
      address,
      noteTaiSan,
      status,
      debt,
      userName,
      manhanvien,
    } = dataSearch;
    const cookies = new Cookies();
    let link = configs.endPoint;
    var apilink = cookies.get("apilink");
    if (typeof apilink != "undefined" && apilink.length > 0) {
      link = apilink;
    }
    link =
      link +
      `quanlychovay/tin-chap-xuat-excel?dateFrom=${dateFrom}&dateTo=${dateTo}&code=${code}&customerName=${customerName}&address=${address}&noteTaiSan=${noteTaiSan}&status=${status}&debt=${debt}&userName=${userName}&userName=${userName}&taiSan=0&manhanvien=${manhanvien}`;
    API_AUTH.get(link).then((res) => {
      var uri = "data:application/vnd.ms-excel," + encodeURIComponent(res.data);
      var downloadLink = document.createElement("a");
      downloadLink.href = uri;
      downloadLink.download = "DanhSachTinChap.xls";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    });
  };
  // xuatExcel2 = () => () => {
  //   let { dataSearch } = this.state;
  //   let {
  //     dateFrom,
  //     dateTo,
  //     code,
  //     customerName,
  //     address,
  //     noteTaiSan,
  //     status,
  //     debt,
  //     userName,
  //   } = dataSearch;
  //   let link =
  //     configs.endPoint +
  //     `quanlychovay/cam-do-xuat-excel2?dateFrom=${dateFrom}&dateTo=${dateTo}&code=${code}&customerName=${customerName}&address=${address}&noteTaiSan=${noteTaiSan}&status=${status}&debt=${debt}&userName=${userName}`;
  //   API_AUTH.get(link).then((res) => {
  //     var uri = 'data:application/vnd.ms-excel,' + encodeURIComponent(res.data);
  //     var downloadLink = document.createElement('a');
  //     downloadLink.href = uri;
  //     downloadLink.download = 'DanhSachTinChap.xls';
  //     document.body.appendChild(downloadLink);
  //     downloadLink.click();
  //     document.body.removeChild(downloadLink);
  //   });
  // };

  xuatExcel3 = () => () => {
    let { showXuatExcel3 } = this.state;
    showXuatExcel3 = true;
    this.setState({ showXuatExcel3 });
  };

  hideXuatExcel = () => () => {
    let { showXuatExcel3 } = this.state;
    showXuatExcel3 = false;
    this.setState({ showXuatExcel3 });
  };
  toggleModalQRThanhToanHD() {
    this.setState({
      isShowModalQRThanhToanHD: !this.state.isShowModalQRThanhToanHD,
    });
  }
  setModalQRThanhToanShow = (hopdong) => () => {
    this.setState({ itemDataQR: hopdong });
    this.toggleModalQRThanhToanHD();
  };

  toggleModalThietLapHienThi() {
    this.setState({
      isShowModalThietLapHienThi: !this.state.isShowModalThietLapHienThi,
    });
  }
  setModalThietLapHienThi = () => () => {
    this.toggleModalThietLapHienThi();
  };
  render() {
    let {
      dataSearch,
      showDongLai,
      choVay,
      showTKNangCao,
      showGiaHanKy,
      showTraBotGoc,
      showVayThem,
      showThayDoiLaiSuat,
      showThayDoiKyLai,
      showTatToan,
      showInChoVay,
      showChiTietKhachHang,
      showChiTietHopDong,
      showDoiTinhTrangNo,
      choVayEdit,
      showXuatExcel3,
      showChiTietSoTienDaTra,
      showChiTietTongSoTienDaTra,
      isCauHinhKhachHangVSNY,
      objThietLapHienThiDanhSach,
    } = this.state;
    let {
      tinchap,
      getLanDongLaiChoVay,
      quanlychovay,
      quanlythuchi,
      user,
      getLichSuGiaHanChoVay,
      postGiaHanChoVay,
      postTraBotGocChoVay,
      getLichSuTraBotGocChoVay,
      postVayThemChoVay,
      postThayDoiLaiSuatChoVay,
      postThayDoiKyThanhToanChoVay,
      getLichSuVayThemChoVay,
      deleteTraBotGocChoVay,
      deleteVayThemChoVay,
      themmoitinchap,
      loaitaisan,
      inthuchi,
      phanquyen,
    } = this.props;

    let {
      TotalMoney,
      ToTalGocConLai,
      TotalPaid,
      TotalPaidToDateNow,
      TotalQuantity,
      TT_Amercement,
      TT_OtheFeeHangKy,
      TT_OtherFee,
      TT_PhiHoaHongTraGop,
      TT_PhiKho,
      TT_PhiPhatDongLai,
      TT_ValueGoc,
      TT_ValueLai,
      TT_PhiPhatTatToan,
      soTienDaTra,
    } = tinchap.objList;
    let { getListTinChapLoading } = tinchap;
    let { isShowFormTinChap } = themmoitinchap;
    let { isShowModalLoaiTaiSan } = loaitaisan;
    let { inThuChiShow } = inthuchi;
    let { PhanQuyenTinChap } = phanquyen;
    let {
      laingay_inhopdonglaingay,
      laingay_themmoilaingay,
      laingay_xuatexceldanhsachlaingay,
      chonngaygiaodich,
      laingay_thaydoitienlai,
      thuchihopdong_suaphieuthuchi,
      thuchihopdong_xoaphieuthuchi,
      laingay_tattoanlaingay,
      laingay_vaythem,
      laingay_thaydoilaisuat,
      laingay_thaydoikylai,
      laingay_trabotgoc,
      laingay_donglailaingay,
      laingay_giahanlaingay,
      tinchap_suatientattoan,
      SuDungPhiPhat_DongLai_TatToan,
      SuDungPhiPhat_DongLai_Cham,
      SuDungCongTacVienNhanVien,
      SuDungMaNhanVien,
      SuDungTachNoXau,
      SuDungSoTienVayConLai,
      SuDungTatToanSom,
    } = PhanQuyenTinChap;
    soTienDaTra =
      TT_Amercement +
      TT_OtheFeeHangKy +
      TT_OtherFee +
      TT_PhiHoaHongTraGop +
      TT_PhiKho +
      TT_PhiPhatDongLai +
      TT_ValueGoc +
      TT_ValueLai +
      TT_PhiPhatTatToan;
    return (
      <LayoutV2>
        <div id="form-repeater">
          <div className="sticky-moman-bh2">
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 title-cd">
                      <div className="media-home align-center-home">
                        <div class="row header">
                          {/* <div className="col-sm-6"> */}
                          <img
                            className="icon-bred-home"
                            src="/app-assets/images/logo-tin-chap-v2.png"
                            alt=""
                          />
                          <h1 className="text-info-home">Tín chấp</h1>
                          {/* </div> */}
                          {/* <div className="col-sm-6"></div> */}
                        </div>
                      </div>
                      <div className="bg-right-breacrumb hidden-mobile-main">
                        <div className="btn-group btn-light-v2">
                          <ul>
                            <li>
                              {laingay_inhopdonglaingay && (
                                <a
                                  href={() => false}
                                  className="icon-bgnew color-print1"
                                  onClick={this.setInChoVayModalShow()}
                                >
                                  <PopoversBootrap
                                    contentText="In hợp đồng"
                                    trigger={["hover", "focus"]}
                                    placement={"top"}
                                  >
                                    <img src="/app-assets/images/logo-print-v2.png" />
                                  </PopoversBootrap>
                                </a>
                              )}
                            </li>
                            <li>
                              {laingay_xuatexceldanhsachlaingay && (
                                <a
                                  href={() => false}
                                  className="icon-bgnew color-print1"
                                  onClick={this.xuatExcel()}
                                >
                                  <PopoversBootrap
                                    contentText=" Xuất excel 1"
                                    trigger={["hover", "focus"]}
                                    placement={"top"}
                                  >
                                    <img src="/app-assets/images/icon-tai-xuong-v2.png" />
                                  </PopoversBootrap>
                                </a>
                              )}
                            </li>
                            <li>
                              {laingay_xuatexceldanhsachlaingay && (
                                <a
                                  href={() => false}
                                  className="icon-bgnew color-print1"
                                  onClick={this.xuatExcel3()}
                                >
                                  <PopoversBootrap
                                    contentText=" Xuất excel 3"
                                    trigger={["hover", "focus"]}
                                    placement={"top"}
                                  >
                                    <img src="/app-assets/images/logo-xoa-v2.png" />
                                  </PopoversBootrap>
                                </a>
                              )}
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="hide-table-main show-mobile-main hidden-des-main">
                        {laingay_themmoilaingay && (
                          <div>
                            <button
                              type="button"
                              className="btn btn-border-new"
                              onClick={this.setModalTinChapShow()}
                              style={{ margin: "0px" }}
                            >
                              <i className="mdi mdi-plus"></i> Thêm mới
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="card border-light mb-3 mt-1 hidden-mobile-main show-table-main card-v2"
                  style={{ marginTop: "-10px" }}
                >
                  <div className="card-body card-body-v2">
                    <div className="search-new">
                      <div className="input-sm-new input-new-18">
                        <label
                          htmlFor="customer-name"
                          className="font-color-default font-bold"
                        >
                          Tìm kiếm
                        </label>
                        <input
                          type="text"
                          className="form-control input-sm"
                          placeholder="Tên, sđt khách hàng"
                          onChange={this.onChangeData.bind(
                            this,
                            "customerName"
                          )}
                          onKeyDown={this.handleKeyDown}
                          value={dataSearch.customerName}
                        />
                      </div>
                      <div className="input-sm-new input-new-18">
                        <label
                          htmlFor="customer-name"
                          className="font-color-default font-bold"
                        >
                          Trạng Thái
                        </label>
                        <ReactDropdown
                          onChange={this._onSelect("status")}
                          options={ChoVayCombo.StatusCombo}
                          placeholder="Select an option"
                          controlClassName="form-control input-sm"
                          arrowClassName=""
                          value={dataSearch.status}
                        />
                      </div>
                      <div className="input-sm-new input-new-18">
                        <label
                          htmlFor="customer-name"
                          className="font-color-default font-bold"
                        >
                          Tình trạng
                        </label>
                        <ReactDropdown
                          onChange={this._onSelect("debt")}
                          // options={ChoVayCombo.TinhTrangCombo}
                          options={
                            SuDungTachNoXau
                              ? this.state.listTinhTrangNo.filter(
                                  (item) =>
                                    item.value !== 50 && item.value !== "50"
                                )
                              : this.state.listTinhTrangNo
                          }
                          placeholder="Select an option"
                          controlClassName="form-control input-sm"
                          value={dataSearch.debt}
                        />
                      </div>
                      <div className="input-sm-new input-new-18">
                        <label
                          htmlFor="customer-name"
                          className="font-color-default font-bold"
                        >
                          Thời gian
                        </label>
                        <ReactDropdown
                          onChange={this._onSelectDate("ThoiGian")}
                          options={ChoVayCombo.ThoiGianCombo}
                          value={ChoVayCombo.ThoiGianDefault}
                          placeholder="Select an option"
                          controlClassName="form-control input-sm"
                        />
                      </div>
                      {SuDungCongTacVienNhanVien && (
                        <div className="input-sm-new input-new-18">
                          <label
                            htmlFor="customer-name"
                            className="font-color-default font-bold"
                          >
                            Mã nhân viên
                          </label>
                          <input
                            type="text"
                            className="form-control input-sm"
                            placeholder="Mã nhân viên"
                            onChange={this.onChangeData.bind(
                              this,
                              "manhanvien"
                            )}
                            onKeyDown={this.handleKeyDown}
                            value={dataSearch.manhanvien}
                          />
                        </div>
                      )}
                      {SuDungMaNhanVien && (
                        <div className="input-sm-new input-new-18">
                          <label
                            htmlFor="customer-name"
                            className="font-color-default font-bold"
                          >
                            Chọn nhân viên
                          </label>
                          <ReactDropdown
                            onChange={this._onSelect("manhanvien")}
                            // options={ChoVayCombo.TinhTrangCombo}
                            options={this.state.listNhanVien}
                            placeholder="Chọn nhân viên"
                            controlClassName="form-control input-sm"
                            value={dataSearch.manhanvien}
                          />
                        </div>
                      )}
                      <div className="input-sm-new input-new-18 search-main-new">
                        <button
                          type="submit"
                          className="btn btn-info-new btn-seach-ds"
                          onClick={this.onSearch}
                        >
                          <i className="la la-search"></i>
                          <span> &nbsp; Tìm kiếm</span>
                        </button>
                        <a
                          href={() => false}
                          className="card-link blue darken-2 text-search-new filter-search"
                          onClick={this.setTKNangCaoModalShow}
                        >
                          <i>
                            <img
                              className="icon-bred-home"
                              src="/app-assets/images/icon-fitter-v2.png"
                              alt=""
                              style={{ scale: "0.9", verticalAlign: "sub" }}
                            />
                          </i>
                        </a>
                        <a
                          href={() => false}
                          className="card-link blue darken-2 text-search-new filter-search"
                          onClick={this.setModalThietLapHienThi()}
                          style={{ marginLeft: 55 }}
                        >
                          <i
                            className="fa fa-cog icon-bred-home"
                            style={{
                              scale: "0.9",
                              verticalAlign: "sub",
                              height: 30,
                            }}
                          ></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="repeater-default hide-table-main show-mobile-main hidden-des-main">
                  <div data-repeater-list="car">
                    <div
                      data-repeater-item
                      className="form row bg-search-form form-mobile-search"
                    >
                      <div
                        className="text-right  search-p mb-1 "
                        style={{ width: "100%" }}
                      >
                        <div className="form-search-mobile-new row">
                          <div
                            className="left-search-mobile-new"
                            style={{ width: "85%" }}
                          >
                            <div className="search-mobile-new">
                              <fieldset className="form-group position-relative mb-0">
                                <input
                                  type="text"
                                  className="form-control input-sm"
                                  placeholder="Tên, mã, sđt khách hàng ..."
                                  onChange={this.onChangeData.bind(
                                    this,
                                    "customerName"
                                  )}
                                  onKeyDown={this.handleKeyDown}
                                  value={dataSearch.customerName}
                                />
                                <div
                                  className="form-control-position"
                                  onClick={this.onSearch}
                                >
                                  <i className="mdi mdi-magnify"></i>
                                </div>
                              </fieldset>
                            </div>
                          </div>
                          <div className="right-search-mobile-new">
                            <div class="icon-search-mobile">
                              <a
                                href={() => false}
                                className="card-link blue darken-2"
                                onClick={this.setTKNangCaoModalShow}
                              >
                                <i>
                                  <PopoversBootrap
                                    contentText="Tìm kiếm nâng cao"
                                    trigger={["hover", "focus"]}
                                    placement={"top"}
                                  >
                                    <img
                                      className="icon-bred-home"
                                      src="/app-assets/images/icon-fitter-v2.png"
                                      alt=""
                                      style={{
                                        scale: "0.9",
                                        verticalAlign: "sub",
                                        marginTop: "-2px",
                                      }}
                                    />
                                  </PopoversBootrap>
                                </i>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="card border-light mb-3 card-v2"
            style={{
              marginLeft: "15px",
              marginRight: "15px",
              marginTop: "-35px",
            }}
          >
            <div className="card-body card-body-v2">
              <div
                className="row col-sm-12 col-md-12 hidden-mobile-main"
                style={{ paddingBottom: "10px" }}
              >
                <div className="col-sm-12 col-md-9">
                  {laingay_themmoilaingay && (
                    <button
                      type="button"
                      className="btn btn-border-new"
                      onClick={this.setModalTinChapShow()}
                    >
                      <img
                        src="/app-assets/images/icon-them-moi-cam-do-v2.png"
                        style={{ paddingBottom: "5px" }}
                      />{" "}
                      Thêm mới
                    </button>
                  )}
                  {/* <button
                    type="button"
                    className="btn btn-border-new"
                    onClick={this.setModalThietLapHienThi()}
                  >
                    <span>
                      <i className="fa fa-cog"></i> Thiết lập hiển thị
                    </span>
                  </button> */}
                </div>
              </div>
              <div className="Left808x200 Table-main-new">
                <div className="loading-page1">
                  <div
                    className={
                      "loader loader-default " +
                      (getListTinChapLoading ? "is-active" : "")
                    }
                  ></div>
                </div>
                <div className="table-mobile sticky-table-bh2 table-mobile-hover">
                  <div
                    className="custom-table-wrapper"
                    style={{ overflowX: "auto", minHeight: "480px" }}
                  >
                    <div
                      className="table-headers"
                      style={{
                        // height: "85px",
                        backgroundColor: "#F5F8FE",
                      }}
                    >
                      {objThietLapHienThiDanhSach.IsAnSTT != true && (
                        <div className="custom-table-header flex-basis-4 flex-basis-6-sm">
                          <p className="color-do-bold center-flex">
                            STT
                            <br />[{TotalQuantity}]
                          </p>
                        </div>
                      )}
                      {isCauHinhKhachHangVSNY == false && (
                        <>
                          {objThietLapHienThiDanhSach.IsAnMaHD != true && (
                            <div className="custom-table-header flex-basis-9 flex-basis-12-sm">
                              <p>Mã hợp đồng</p>
                            </div>
                          )}
                          {objThietLapHienThiDanhSach.IsAnNhanVien != true &&
                            (SuDungCongTacVienNhanVien || SuDungMaNhanVien) && (
                              <div className="custom-table-header flex-basis-6 flex-basis-6-sm">
                                <p>
                                  {SuDungCongTacVienNhanVien
                                    ? "Mã nhân viên"
                                    : "Nhân viên"}
                                </p>
                              </div>
                            )}
                          {objThietLapHienThiDanhSach.IsAnTenKH != true && (
                            <div
                              className={`custom-table-header ${
                                SuDungCongTacVienNhanVien || SuDungMaNhanVien
                                  ? "flex-basis-12 flex-basis-11-8-sm"
                                  : "flex-basis-10 flex-basis-11-8-sm"
                              }`}
                            >
                              <p>Tên khách hàng</p>
                            </div>
                          )}
                        </>
                      )}
                      {isCauHinhKhachHangVSNY == true && (
                        <>
                          {objThietLapHienThiDanhSach.IsAnTenKH != true && (
                            <div
                              className={`custom-table-header ${
                                SuDungCongTacVienNhanVien || SuDungMaNhanVien
                                  ? "flex-basis-12 flex-basis-11-8-sm"
                                  : "flex-basis-10 flex-basis-11-8-sm"
                              }`}
                            >
                              <p>Tên khách hàng</p>
                            </div>
                          )}
                          {objThietLapHienThiDanhSach.IsAnMaHD != true && (
                            <div className="custom-table-header flex-basis-9 flex-basis-12-sm">
                              <p>Mã hợp đồng</p>
                            </div>
                          )}
                          {objThietLapHienThiDanhSach.IsAnNhanVien != true &&
                            (SuDungCongTacVienNhanVien || SuDungMaNhanVien) && (
                              <div className="custom-table-header flex-basis-6 flex-basis-6-sm">
                                <p>
                                  {SuDungCongTacVienNhanVien
                                    ? "Mã nhân viên"
                                    : "Nhân viên"}
                                </p>
                              </div>
                            )}
                        </>
                      )}
                      {objThietLapHienThiDanhSach.IsAnTinChap != true && (
                        <div className="custom-table-header flex-basis-8 flex-basis-6-sm">
                          <p className="text-center">Tín chấp</p>
                        </div>
                      )}
                      {objThietLapHienThiDanhSach.IsAnSoTienVay != true &&
                        this.state.isCauHinhKhachHangBinhAn == false && (
                          <div className="custom-table-header flex-basis-9-5 flex-basis-13-sm">
                            <p className="text-right">
                              Số tiền vay
                              <br />
                              <PopoversBootrap
                                contentText={formatNumber(TotalMoney)}
                                trigger={["hover", "focus"]}
                                placement={"bottom"}
                              >
                                <span className="color-do-bold">
                                  {(() => {
                                    if (TotalMoney >= 10000000000) {
                                      return `${formatNumber(
                                        (TotalMoney / 1000).toFixed(0)
                                      )}K`;
                                    }
                                    return formatNumber(TotalMoney);
                                  })()}
                                </span>
                              </PopoversBootrap>
                            </p>
                          </div>
                        )}
                      {this.state.isCauHinhKhachHangBinhAn == true && (
                        <div className="custom-table-header flex-basis-9-5 flex-basis-13-sm">
                          <p className="text-right">
                            Tiền đưa khách
                            <br />
                            <PopoversBootrap
                              contentText={formatNumber(TotalMoney)}
                              trigger={["hover", "focus"]}
                              placement={"bottom"}
                            >
                              <span className="color-do-bold">
                                {(() => {
                                  if (TotalMoney >= 10000000000) {
                                    return `${formatNumber(
                                      (TotalMoney / 1000).toFixed(0)
                                    )}K`;
                                  }
                                  return formatNumber(TotalMoney);
                                })()}
                              </span>
                            </PopoversBootrap>
                          </p>
                        </div>
                      )}
                      {objThietLapHienThiDanhSach.IsAnSoTienDaTra != true && (
                        <div className="custom-table-header flex-basis-9-5 flex-basis-13-sm">
                          <p className="text-right">
                            Số tiền đã trả
                            <br />
                            <PopoversBootrap
                              contentText={formatNumber(soTienDaTra)}
                              trigger={["hover", "focus"]}
                              placement={"bottom"}
                            >
                              <span className="color-xanh-bold">
                                <a
                                  id=""
                                  href={() => false}
                                  onClick={this.setModalChiTietTongTienDaTraShow()}
                                >
                                  {formatCurrency2(soTienDaTra)}
                                </a>
                              </span>
                            </PopoversBootrap>
                          </p>
                        </div>
                      )}
                      {objThietLapHienThiDanhSach.IsAnTienVayConLai != true && (
                        <div className="custom-table-header flex-basis-9-5 flex-basis-13-sm">
                          <p className="text-right">
                            Tiền vay còn lại
                            <br />
                            <PopoversBootrap
                              contentText={formatNumber(
                                Math.round(ToTalGocConLai, 0)
                              )}
                              trigger={["hover", "focus"]}
                              placement={"bottom"}
                            >
                              <span className="color-cam-bold">
                                {(() => {
                                  if (
                                    Math.round(ToTalGocConLai, 0) >= 10000000000
                                  ) {
                                    return `${formatNumber(
                                      (
                                        Math.round(ToTalGocConLai, 0) / 1000
                                      ).toFixed(0)
                                    )}K`;
                                  }
                                  return formatNumber(
                                    Math.round(ToTalGocConLai, 0)
                                  );
                                })()}
                              </span>
                            </PopoversBootrap>
                          </p>
                        </div>
                      )}
                      {/* )} */}
                      {objThietLapHienThiDanhSach.IsAnChiPhiVayToiHomNay !=
                        true && (
                        <div className="custom-table-header flex-basis-9-5 flex-basis-13-sm">
                          <p className="text-right">
                            Lãi đến hôm nay
                            <br />
                            <PopoversBootrap
                              contentText={formatNumber(
                                Math.round(TotalPaidToDateNow, 0)
                              )}
                              trigger={["hover", "focus"]}
                              placement={"bottom"}
                            >
                              <span className="color-cam-bold">
                                {(() => {
                                  if (
                                    Math.round(TotalPaidToDateNow, 0) >=
                                    10000000000
                                  ) {
                                    return `${formatNumber(
                                      (
                                        Math.round(TotalPaidToDateNow, 0) / 1000
                                      ).toFixed(0)
                                    )}K`;
                                  }
                                  return formatNumber(
                                    Math.round(TotalPaidToDateNow, 0)
                                  );
                                })()}
                              </span>
                            </PopoversBootrap>
                          </p>
                        </div>
                      )}{" "}
                      {objThietLapHienThiDanhSach.IsAnTrangThai != true && (
                        <div className="custom-table-header flex-basis-8 flex-basis-8-sm">
                          <p className="tab-header text-center">Trạng thái</p>
                        </div>
                      )}
                      {objThietLapHienThiDanhSach.IsAnChucNang != true && (
                        <div className="custom-table-header flex-basis-16 flex-basis-15-6-sm action-cell">
                          <p className="tab-header">Chức năng</p>
                        </div>
                      )}
                    </div>
                    <div className="custom-table-body">
                      {this.renderTableRows()}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="card border-light mb-3 card-v2"
            style={{
              marginLeft: "15px",
              marginRight: "15px",
              marginTop: "-25px",
            }}
          >
            <div className="card-body card-body-v2">
              <div className="row">
                <div className="col-sm-12 col-md-6">
                  <span className="color7">
                    {TotalQuantity === 0 ? (
                      "Hiển thị 0 - 0 / Tổng số 0"
                    ) : (
                      <>
                        Hiển thị{" "}
                        {(dataSearch.pageIndex - 1) * dataSearch.pageSize + 1} -{" "}
                        {Math.min(
                          dataSearch.pageIndex * dataSearch.pageSize,
                          TotalQuantity
                        )}{" "}
                        / Tổng số {TotalQuantity}
                      </>
                    )}
                  </span>
                </div>
                <div className="col-sm-12 col-md-6">
                  <div
                    className={
                      "paniation-new paniation-new1 d-flex justify-content-center " +
                      (TotalQuantity === 0 ? "hidden" : "")
                    }
                    style={{ float: "right" }}
                  >
                    <nav aria-label="Page navigation">
                      <Pagination
                        activePage={dataSearch.pageIndex}
                        itemsCountPerPage={dataSearch.pageSize}
                        totalItemsCount={TotalQuantity}
                        pageRangeDisplayed={5}
                        onChange={this.handlePageChange}
                        itemClass="page-item border-none"
                        linkClass="page-link border-none"
                        activeClass="active"
                      />
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {isShowFormTinChap && (
          <ThemMoiTinChapContainer
            show={
              isShowFormTinChap &&
              !isShowModalLoaiTaiSan &&
              !showInChoVay &&
              !inThuChiShow
            }
            onHide={this.setModalTinChapShow(null)}
            data={choVayEdit}
            inPhieuThu={this.setInThuChiModalShow}
            inHopDong={this.setInChoVayModalShowTM}
            setIsTinChapReturn={this.setIsTinChapReturn}
            SuDungPhiPhat_DongLai_TatToan={SuDungPhiPhat_DongLai_TatToan}
            SuDungPhiPhat_DongLai_Cham={SuDungPhiPhat_DongLai_Cham}
            SuDungCongTacVienNhanVien={SuDungCongTacVienNhanVien}
            SuDungTatToanSom={SuDungTatToanSom}
          ></ThemMoiTinChapContainer>
        )}
        {showChiTietKhachHang && (
          <CustomerDetail
            onHide={this.setModalChiTietKhachHangShow(choVay)}
            show={showChiTietKhachHang && !showChiTietHopDong}
            showChiTietHopDong={this.setModalChiTietHopDongShow}
            data={choVay}
          ></CustomerDetail>
        )}

        {showDongLai && (
          <DongLaiContainer
            show={showDongLai && !inThuChiShow}
            onHide={this.setDongLaiModalShow(choVay)}
            onShowPhieuThu={this.setInThuChiModalShow}
            data={choVay}
            thaydoitienlai={laingay_thaydoitienlai}
            chonngaygiaodich={chonngaygiaodich}
            xoaphieuthuchi={thuchihopdong_xoaphieuthuchi}
            SuDungPhiPhat_DongLai_TatToan={SuDungPhiPhat_DongLai_TatToan}
            SuDungPhiPhat_DongLai_Cham={SuDungPhiPhat_DongLai_Cham}
            isCauHinhKhachHangVSNY={isCauHinhKhachHangVSNY}
            buttonLeft={
              <ButtonChuyenForm
                // showDongLai={this.setDongLaiModalShow(choVay)}
                showTatToan={this.setModalTatToanShow(choVay)}
                quyenTatToan={laingay_tattoanlaingay}
                showGiaHaKy={this.setModalGiaHanShow(choVay)}
                quyenGiaHan={laingay_giahanlaingay}
                showTraBotGoc={this.setModalTraBotGocShow(choVay)}
                quyenTraBotGoc={laingay_trabotgoc}
                showVayThem={this.setModalVayThemShow(choVay)}
                quyenVayThem={laingay_vaythem}
                showThayDoiLaiSuat={this.setModalThayDoiLaiSuatShow(choVay)}
                quyenThayDoiLaiSuat={laingay_thaydoilaisuat}
                IsDuNoGiamDan={choVay.IsDuNoGiamDan}
                IsKieuTraGocLai={choVay.IsKieuTraGocLai}
                // showThayDoiKyLai={this.setModalThayDoiKyLaiShow(choVay)}
              ></ButtonChuyenForm>
            }
          ></DongLaiContainer>
        )}
        {showGiaHanKy && (
          <GiaHanKy
            show={showGiaHanKy}
            data={choVay}
            getLanDongLaiChoVay={getLanDongLaiChoVay}
            quanlychovay={quanlychovay}
            quanlythuchi={quanlythuchi}
            onHide={this.setModalGiaHanShow(choVay)}
            getLichSuGiaHanChoVay={getLichSuGiaHanChoVay}
            postGiaHanChoVay={postGiaHanChoVay}
            buttonLeft={
              <ButtonChuyenForm
                showDongLai={this.setDongLaiModalShow(choVay)}
                quyenDongLai={laingay_donglailaingay}
                showTatToan={this.setModalTatToanShow(choVay)}
                quyenTatToan={laingay_tattoanlaingay}
                // showGiaHaKy={this.setModalGiaHanShow(choVay)}
                showTraBotGoc={this.setModalTraBotGocShow(choVay)}
                quyenTraBotGoc={laingay_trabotgoc}
                showVayThem={this.setModalVayThemShow(choVay)}
                quyenVayThem={laingay_vaythem}
                showThayDoiLaiSuat={this.setModalThayDoiLaiSuatShow(choVay)}
                quyenThayDoiLaiSuat={laingay_thaydoilaisuat}
                IsDuNoGiamDan={choVay.IsDuNoGiamDan}
                IsKieuTraGocLai={choVay.IsKieuTraGocLai}
                // showThayDoiKyLai={this.setModalThayDoiKyLaiShow(choVay)}
              ></ButtonChuyenForm>
            }
          ></GiaHanKy>
        )}
        {showTraBotGoc && (
          <TraBotGoc
            show={showTraBotGoc && !inThuChiShow}
            data={choVay}
            getLanDongLaiChoVay={getLanDongLaiChoVay}
            postTraBotGocChoVay={postTraBotGocChoVay}
            getLichSuTraBotGocChoVay={getLichSuTraBotGocChoVay}
            quanlychovay={quanlychovay}
            quanlythuchi={quanlythuchi}
            onHide={this.setModalTraBotGocShow(choVay)}
            deleteTraBotGoc={deleteTraBotGocChoVay}
            chonngaygiaodich={chonngaygiaodich}
            quyenThayDoiLaiSuat={laingay_thaydoilaisuat}
            buttonLeft={
              <ButtonChuyenForm
                showDongLai={this.setDongLaiModalShow(choVay)}
                quyenDongLai={laingay_donglailaingay}
                showTatToan={this.setModalTatToanShow(choVay)}
                quyenTatToan={laingay_tattoanlaingay}
                showGiaHaKy={this.setModalGiaHanShow(choVay)}
                quyenGiaHan={laingay_giahanlaingay}
                showThayDoiLaiSuat={this.setModalThayDoiLaiSuatShow(choVay)}
                quyenThayDoiLaiSuat={laingay_thaydoilaisuat}
                showVayThem={this.setModalVayThemShow(choVay)}
                quyenVayThem={laingay_vaythem}
                IsDuNoGiamDan={choVay.IsDuNoGiamDan}
                IsKieuTraGocLai={choVay.IsKieuTraGocLai}
                // showThayDoiKyLai={this.setModalThayDoiKyLaiShow(choVay)}
              ></ButtonChuyenForm>
            }
            phanquyen={phanquyen}
          ></TraBotGoc>
        )}
        {showVayThem && (
          <VayThem
            show={showVayThem && !inThuChiShow}
            data={choVay}
            getLanDongLaiChoVay={getLanDongLaiChoVay}
            postVayThemChoVay={postVayThemChoVay}
            getLichSuVayThemChoVay={getLichSuVayThemChoVay}
            quanlychovay={quanlychovay}
            quanlythuchi={quanlythuchi}
            onHide={this.setModalVayThemShow(choVay)}
            deleteVayThem={deleteVayThemChoVay}
            chonngaygiaodich={chonngaygiaodich}
            quyenThayDoiLaiSuat={laingay_thaydoilaisuat}
            buttonLeft={
              <ButtonChuyenForm
                showDongLai={this.setDongLaiModalShow(choVay)}
                quyenDongLai={laingay_donglailaingay}
                showTatToan={this.setModalTatToanShow(choVay)}
                quyenTatToan={laingay_tattoanlaingay}
                showGiaHaKy={this.setModalGiaHanShow(choVay)}
                quyenGiaHan={laingay_giahanlaingay}
                showTraBotGoc={this.setModalTraBotGocShow(choVay)}
                quyenTraBotGoc={laingay_trabotgoc}
                IsDuNoGiamDan={choVay.IsDuNoGiamDan}
                IsKieuTraGocLai={choVay.IsKieuTraGocLai}
                // showThayDoiKyLai={this.setModalThayDoiKyLaiShow(choVay)}
              ></ButtonChuyenForm>
            }
            phanquyen={phanquyen}
          ></VayThem>
        )}

        {showThayDoiLaiSuat && (
          <ThayDoiLaiSuat
            show={showThayDoiLaiSuat && !inThuChiShow}
            data={choVay}
            getLanDongLaiChoVay={getLanDongLaiChoVay}
            postThayDoiLaiSuatChoVay={postThayDoiLaiSuatChoVay}
            getLichSuVayThemChoVay={getLichSuVayThemChoVay}
            quanlychovay={quanlychovay}
            quanlythuchi={quanlythuchi}
            onHide={this.setModalThayDoiLaiSuatShow(choVay)}
            deleteVayThem={deleteVayThemChoVay}
            chonngaygiaodich={chonngaygiaodich}
            buttonLeft={
              <ButtonChuyenForm
                showDongLai={this.setDongLaiModalShow(choVay)}
                quyenDongLai={laingay_donglailaingay}
                showTatToan={this.setModalTatToanShow(choVay)}
                quyenTatToan={laingay_tattoanlaingay}
                showGiaHaKy={this.setModalGiaHanShow(choVay)}
                quyenGiaHan={laingay_giahanlaingay}
                showTraBotGoc={this.setModalTraBotGocShow(choVay)}
                quyenTraBotGoc={laingay_trabotgoc}
                IsDuNoGiamDan={choVay.IsDuNoGiamDan}
                IsKieuTraGocLai={choVay.IsKieuTraGocLai}
                showVayThem={this.setModalVayThemShow(choVay)}
                // showThayDoiKyLai={this.setModalThayDoiKyLaiShow(choVay)}
              ></ButtonChuyenForm>
            }
            phanquyen={phanquyen}
          ></ThayDoiLaiSuat>
        )}

        {showTatToan && (
          <TatToanContainer
            show={showTatToan && !inThuChiShow}
            data={choVay}
            onHide={this.setModalTatToanShow(choVay)}
            chonngaygiaodich={chonngaygiaodich}
            quyenSuaTienTatToan={tinchap_suatientattoan}
            SuDungPhiPhat_DongLai_TatToan={SuDungPhiPhat_DongLai_TatToan}
            SuDungPhiPhat_DongLai_Cham={SuDungPhiPhat_DongLai_Cham}
            SuDungTatToanSom={SuDungTatToanSom}
            buttonLeft={
              <ButtonChuyenForm
                showDongLai={this.setDongLaiModalShow(choVay)}
                quyenDongLai={laingay_donglailaingay}
                //showTatToan={this.setModalTatToanShow(choVay)}
                showGiaHaKy={this.setModalGiaHanShow(choVay)}
                quyenGiaHan={laingay_giahanlaingay}
                showTraBotGoc={this.setModalTraBotGocShow(choVay)}
                quyenTraBotGoc={laingay_trabotgoc}
                showVayThem={this.setModalVayThemShow(choVay)}
                showThayDoiLaiSuat={this.setModalThayDoiLaiSuatShow(choVay)}
                quyenThayDoiLaiSuat={laingay_thaydoilaisuat}
                IsDuNoGiamDan={choVay.IsDuNoGiamDan}
                IsKieuTraGocLai={choVay.IsKieuTraGocLai}
                // showThayDoiKyLai={this.setModalThayDoiKyLaiShow(choVay)}
              ></ButtonChuyenForm>
            }
          ></TatToanContainer>
        )}
        {showThayDoiKyLai && (
          <ThayDoiKyLai
            show={showThayDoiKyLai && !inThuChiShow}
            data={choVay}
            getLanDongLaiChoVay={getLanDongLaiChoVay}
            postThayDoiLaiSuatChoVay={postThayDoiLaiSuatChoVay}
            getLichSuVayThemChoVay={getLichSuVayThemChoVay}
            quanlychovay={quanlychovay}
            quanlythuchi={quanlythuchi}
            onHide={this.setModalThayDoiKyLaiShow(choVay)}
            deleteVayThem={deleteVayThemChoVay}
            chonngaygiaodich={chonngaygiaodich}
            buttonLeft={
              <ButtonChuyenForm
                showDongLai={this.setDongLaiModalShow(choVay)}
                quyenDongLai={laingay_donglailaingay}
                //showTatToan={this.setModalTatToanShow(choVay)}
                showGiaHaKy={this.setModalGiaHanShow(choVay)}
                quyenGiaHan={laingay_giahanlaingay}
                showTraBotGoc={this.setModalTraBotGocShow(choVay)}
                quyenTraBotGoc={laingay_trabotgoc}
                showVayThem={this.setModalVayThemShow(choVay)}
                showThayDoiLaiSuat={this.setModalThayDoiLaiSuatShow(choVay)}
                quyenThayDoiLaiSuat={laingay_thaydoilaisuat}
                IsDuNoGiamDan={choVay.IsDuNoGiamDan}
                IsKieuTraGocLai={choVay.IsKieuTraGocLai}
                showThayDoiKyLai={this.setModalThayDoiKyLaiShow(choVay)}
                quyenThayDoiKyLai={laingay_thaydoikylai}
              ></ButtonChuyenForm>
            }
            phanquyen={phanquyen}
          ></ThayDoiKyLai>
        )}
        <SearchChoVay
          data={dataSearch}
          show={showTKNangCao}
          onHide={this.setTKNangCaoModalShow}
          userCombo={user.combo}
          listTinhTrangNo={this.state.listTinhTrangNo}
        ></SearchChoVay>
        {showInChoVay && (
          <InChoVay
            data={choVay}
            show={showInChoVay}
            onHide={this.setInChoVayModalShow()}
          ></InChoVay>
        )}

        {inThuChiShow && (
          <InThuChiContainer
            show={inThuChiShow}
            onHide={this.setInThuChiModalShow()}
          ></InThuChiContainer>
        )}
        {showChiTietHopDong && (
          <ChiTietHopDongContainer
            show={showChiTietHopDong}
            onHide={this.setModalChiTietHopDongShow(choVay)}
            data={choVay}
          ></ChiTietHopDongContainer>
        )}
        {showDoiTinhTrangNo && (
          <DoiTinhTrangNoContainer
            show={showDoiTinhTrangNo}
            onHide={this.setModalDoiTinhTrangNoShow(choVay)}
            data={choVay}
          ></DoiTinhTrangNoContainer>
        )}

        <XoaHopDongContainer
          data={choVay}
          getList={this.getListData()}
        ></XoaHopDongContainer>

        <GuiEmailContainer data={choVay}></GuiEmailContainer>
        <TinNhanContainer data={choVay}></TinNhanContainer>
        {isShowModalLoaiTaiSan && (
          <ThemMoiLoaiTaiSanContainer
            show={isShowModalLoaiTaiSan}
            onHide={this.hideModalLoaiTaiSanTM}
          ></ThemMoiLoaiTaiSanContainer>
        )}

        {showXuatExcel3 && (
          <XuatExcelTinChap
            dataSearch={dataSearch}
            show={showXuatExcel3}
            onHide={this.hideXuatExcel()}
          ></XuatExcelTinChap>
        )}

        {showChiTietSoTienDaTra && (
          <ChiTietSoTienDaTraContainer
            show={showChiTietSoTienDaTra}
            onHide={this.setModalChiTietTienDaTraShow(choVay)}
            data={choVay}
          ></ChiTietSoTienDaTraContainer>
        )}
        {showChiTietTongSoTienDaTra && (
          <ChiTietTongSoTienDaTraContainer
            show={showChiTietTongSoTienDaTra}
            onHide={this.setModalChiTietTongTienDaTraShow()}
            TT_Amercement={TT_Amercement}
            TT_OtheFeeHangKy={TT_OtheFeeHangKy}
            TT_OtherFee={TT_OtherFee}
            TT_PhiHoaHongTraGop={TT_PhiHoaHongTraGop}
            TT_PhiKho={TT_PhiKho}
            TT_PhiPhatDongLai={TT_PhiPhatDongLai}
            TT_ValueGoc={TT_ValueGoc}
            TT_ValueLai={TT_ValueLai}
            TT_PhiPhatTatToan={TT_PhiPhatTatToan}
          ></ChiTietTongSoTienDaTraContainer>
        )}
        {this.state.isShowModalQRThanhToanHD && (
          <ModelQRThanhToanHD
            show={this.state.isShowModalQRThanhToanHD}
            onHide={this.toggleModalQRThanhToanHD.bind(this)}
            hopdong={this.state.itemDataQR}
          />
        )}
        {this.state.isShowModalThietLapHienThi && (
          <ModelThietLapHienThi
            show={this.state.isShowModalThietLapHienThi}
            onHide={this.toggleModalThietLapHienThi.bind(this)}
            data={this.state.objThietLapHienThiDanhSach}
            SuDungCongTacVienNhanVien={SuDungCongTacVienNhanVien}
            SuDungMaNhanVien={SuDungMaNhanVien}
            getThietLapHienThi={this.getThietLapHienThi.bind(this)}
          />
        )}
      </LayoutV2>
    );
  }
}

TinChap.propTypes = {
  getList: PropTypes.func,
};

export default TinChap;
